<template>
    <div class="home">
        <pay isFrom='hotel'></pay>
        <Footer></Footer>
    </div>
</template>
<script>
import Pay from '../../components/pay/index.vue'
import Footer from '../../components/footer/index.vue'
export default {
    data() {
      return {

      }
    },
    components: {
      Pay,
      Footer
    }
}
</script>
